"use client";

import { setUser, signOutThunk } from "@/features/auth/authSlice";
import type { AppDispatch, RootState } from "@/store/store";
import { useLazyQuery } from "@apollo/client";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GET_USER_QUERY } from "../../../graphql/queries/getUserById";

// Boot-time session validation against the server. ProtectedRoute handles
// the synchronous token-expiry check and the visibility-resume path; this
// hook complements that by catching server-side invalidations (user
// disabled, refresh family revoked) that a client-side JWT decode can't see.
const InitUser = () => {
  const dispatch = useDispatch<AppDispatch>();
  const user = useSelector((state: RootState) => state.auth.user);
  const validatedRef = useRef(false);
  const [getCurrentUser, { data, error }] = useLazyQuery(GET_USER_QUERY, {
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    if (data?.getCurrentUser) {
      dispatch(setUser(data.getCurrentUser));
    }
  }, [data, dispatch]);

  useEffect(() => {
    if (!error) return;
    console.warn("Session validation failed on boot:", error.message);
    void dispatch(signOutThunk());
  }, [error, dispatch]);

  useEffect(() => {
    if (validatedRef.current) return;
    const token = typeof window !== "undefined"
      ? localStorage.getItem("accessToken")
      : null;
    if (!token && !user) return;
    validatedRef.current = true;
    getCurrentUser();
  }, [user, getCurrentUser]);

  return null;
};

export default InitUser;
